import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as episodeMeasurementActions from '../actions/episode-measurement.actions';
import { RulerState } from '../../ruler/reducers/ruler.reducer';

declare module 'react-redux' {
  interface DefaultRootState {
    episodeMeasurement: RulerState;
  }
}

const initialStateFactory = (): RulerState => ({
  start: 0,
  end: 0,
  updateMode: null,
});

export default reducer(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(
    episodeMeasurementActions.stop,
    ({ start, end }): RulerState => ({
      start,
      end,
      updateMode: null,
    }),
  ),
  on(
    episodeMeasurementActions.setBoundary,
    ({ start, end }, { boundary, timestamp }): RulerState => {
      const [sortedStart, sortedEnd] = [start, end].sort((a, b) => a - b);

      return {
        start: timestamp ?? sortedStart,
        end: timestamp ?? sortedEnd,
        boundary,
        updateMode: 'boundary',
      };
    },
  ),
  on(
    episodeMeasurementActions.setMoving,
    (state, { timestamp }): RulerState => ({
      ...state,
      previousTimestamp: timestamp,
      updateMode: 'move',
    }),
  ),
  on(
    episodeMeasurementActions.setTimestamp,
    (state, { timestamp }): RulerState => {
      switch (state.updateMode) {
        case 'boundary':
          return {
            ...state,
            [state.boundary]: timestamp,
          };
        case 'move': {
          const delta = state.previousTimestamp - timestamp;
          return {
            ...state,
            start: state.start - delta,
            end: state.end - delta,
            previousTimestamp: timestamp,
          };
        }
        default:
          return state;
      }
    },
  ),
  on(episodeMeasurementActions.setRange, (state, { start, end }) => ({
    ...state,
    start,
    end,
  })),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { ruler } }): RulerState => {
      if (!ruler) {
        return state;
      }
      return { ...state, ...ruler };
    },
  ),
);
